export const APP_CONFIG = {
    SUPPORT_EMAIL: 'support@pivotkit.biz',
    THRESHOLDS: {
        MIN_INTERVIEWS_FOR_PIVOT: 3,
    },
    LINKS: {
        // Add other external links here as needed
    }
};
